
/**
 * PALTFORM MODULES
 */
import BaseService   from '@shared/services/base/BaseService'
import ENDPOINTS     from '@shared/lib/constants/endpoints';
import EVENT_NAMES   from '@shared/lib/constants/events';

/**
 * Prepaid Session Service
 *
 * @class      SessionService (name)
 */
function SessionService(component) {
  this.component        = component;
  this.event_group      = EVENT_NAMES.PLATFORM.SESSIONS_PREPAID;
  this.hostname         = process.env.REACT_APP_PLATFORM_API_BASE_URL;
  this.create_endpoint  = this.hostname + ENDPOINTS.PLATFORM.SESSIONS_PREPAID_CREATE;
  this.read_endpoint    = this.hostname + ENDPOINTS.PLATFORM.SESSIONS_PREPAID_SHOW;
  this.delete_endpoint  = this.hostname + ENDPOINTS.PLATFORM.SESSIONS_PREPAID_DELETE;
  this.used_interceptor = false;
}

SessionService.prototype = Object.assign(SessionService.prototype, BaseService.prototype);


export default SessionService;